export default "__VITE_ASSET__0n0U$a0t__"